import logo from './logo.svg';
import './App.css';
import MainPage from './Component/MainPage';

function App() {
  return (
    <div className="App">
      <MainPage/>
    </div>
  );
}

export default App;
